const state = {
  shops: {
    isLoading: false,
    data: [],
    totalElements: 0,
  },
  shopsRecommend: {
    isLoading: false,
    data: [],
    totalElements: 0,
  },
  shop: {
    address: '',
    beneFits: [],
    chatCnt: 0,
    counselEnd: '',
    counselStart: '',
    evaluationScore: 0,
    followCnt: 0,
    followed: false,
    id: 0,
    info: '',
    latitude: 0,
    longitude: 0,
    name: '',
    responseRate: 0,
    reviews: [],
    storePhotos: [],
    telNumber: '',
    storeMessages: {
      msg_a: [],
      msg_b: [],
    },
  },
  shopPriorConsent: {},
  vouchersUseResult: {},
  shopVouchers: [],
};

export default state;
